var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InputPhone',{attrs:{"no-country-selector":false,"disabled":_vm.context.attributes.disabled},on:{"validatePhone":_vm.validatePhone},model:{value:(_vm.context.model),callback:function ($$v) {_vm.$set(_vm.context, "model", $$v)},expression:"context.model"}})
}
var staticRenderFns = []

export { render, staticRenderFns }